/**
 * This helper generates a random hex color Math.random.
 *
 * @export
 * @returns {String} Random hex color
 */
export default function (): string {
  return `#${Math.floor(Math.random() * 16777215).toString(16)}`;
}
